var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import { InputFieldsContainer } from 'components/Shared/InputFieldsContainer/InputFieldsContainer';
import { GSA_CHANNEL } from 'utils/constants';
import { useCpaProduct } from 'components/Cpa/CpaProduct/CpaProductContextProvider';
import { ActionType, InputFieldType } from 'models/Input/InputModels';
import { BannerIconType, BannerMessageType, useBanner } from 'components/Shared/BannerContext/BannerContext';
import { CustomEngSite, CustomEngStatus, CustomQuoteStatus } from '@millerknoll/pub-api-schema';
import { inputFieldsContainerHelper } from 'components/Shared/InputFieldsContainer/InputFieldsContainerHelper';
import { useLookupSearch } from 'hooks/useLookupSearch';
import { LookupType } from 'services/api/search-service';
import { BUSINESS_UNIT_CODE_VALUE_MAPPINGS, EXTRA_DATA_FIELD_NAMES, DEFAULT_FSCCHAINOFCUSTODY, FSC_TYPE, BRAND_CODE, COMPLEXITY, createLock, } from 'utils/cpa-utils';
import { getUserOrSignIn } from 'services/auth/AuthService';
export function CpaExtraDataCustomFieldsSpecials(_a) {
    var _b;
    var _this = this;
    var _c, _d;
    var disabledEdit = _a.disabledEdit;
    var cpaProductContext = useCpaProduct();
    var _e = useBanner(), setBannerMessage = _e.setBannerMessage, setBannerType = _e.setBannerType, setBannerIcon = _e.setBannerIcon, setShowBanner = _e.setShowBanner, setIsRefreshEnabled = _e.setIsRefreshEnabled;
    /**
     * Declare state to hold field values of all columns , key as column heading
     */
    var _f = useState(buildFieldValues(undefined)), fieldValues = _f[0], setFieldValues = _f[1];
    var weightClassCodeValidate = useLookupSearch(LookupType.WeightClassCode, (_c = fieldValues[EXTRA_DATA_FIELD_NAMES.WEIGHT_CLASS_CODE]) === null || _c === void 0 ? void 0 : _c.value);
    var productFunctionCodeValidate = useLookupSearch(LookupType.ProductFunctionCode, (_d = fieldValues[EXTRA_DATA_FIELD_NAMES.PRODUCT_FUNCTION_CODE]) === null || _d === void 0 ? void 0 : _d.value);
    /**
     * Holds Column Definition and Initial Values of the Column
     */
    var colDef = {
        title: { displayText: 'Extra Data:' },
        rowGap: '24px',
        showActions: true,
        preventReadOnly: true,
        disabled: disabledEdit,
        fields: (_b = {},
            _b[EXTRA_DATA_FIELD_NAMES.LEAD_TIME] = {
                fieldName: 'Lead Time:',
                displaySeq: 0,
                input: {
                    type: InputFieldType.ENUM,
                    allowedFieldValues: ['Assigned'],
                },
                hasTextField: false,
                hasLookup: false,
            },
            _b[EXTRA_DATA_FIELD_NAMES.GSA] = {
                fieldName: 'GSA:',
                displaySeq: 1,
                input: {
                    type: InputFieldType.RADIO,
                    allowedFieldValues: ['Yes', 'No'],
                },
                hasTextField: true,
                hasLookup: false,
            },
            _b[EXTRA_DATA_FIELD_NAMES.FSC_TYPE] = {
                fieldName: 'Forest Certification:',
                displaySeq: 2,
                input: {
                    type: InputFieldType.ENUM,
                    allowedFieldValues: Object.values(FSC_TYPE),
                },
                hasTextField: false,
                hasLookup: false,
            },
            _b[EXTRA_DATA_FIELD_NAMES.COMPLEXITY] = {
                fieldName: 'Manufacturing Complexity:',
                displaySeq: 3,
                input: {
                    type: InputFieldType.ENUM,
                    allowedFieldValues: Object.values(COMPLEXITY),
                },
                hasTextField: false,
                hasLookup: false,
            },
            _b[EXTRA_DATA_FIELD_NAMES.WEIGHT_CLASS_CODE] = {
                fieldName: 'Weight Class Code:',
                displaySeq: 4,
                input: {
                    type: InputFieldType.STRING,
                    validations: {
                        maxLength: 10,
                    },
                },
                hasTextField: false,
                hasLookup: true,
            },
            _b[EXTRA_DATA_FIELD_NAMES.PRODUCT_FUNCTION_CODE] = {
                fieldName: 'Product Func. Code:',
                displaySeq: 5,
                input: {
                    type: InputFieldType.STRING,
                    validations: {
                        maxLength: 50,
                    },
                },
                hasTextField: false,
                hasLookup: true,
            },
            _b[EXTRA_DATA_FIELD_NAMES.QUOTE_STATUS] = {
                fieldName: 'Custom Quote Status:',
                displaySeq: 6,
                input: {
                    type: InputFieldType.ENUM,
                    allowedFieldValues: Object.values(CustomQuoteStatus),
                },
                hasTextField: false,
                hasLookup: false,
            },
            _b[EXTRA_DATA_FIELD_NAMES.ENG_STATUS] = {
                fieldName: 'Custom Engineering Status:',
                displaySeq: 7,
                input: {
                    type: InputFieldType.ENUM,
                    allowedFieldValues: Object.values(CustomEngStatus),
                },
                hasTextField: false,
                hasLookup: false,
            },
            _b[EXTRA_DATA_FIELD_NAMES.PROPRIETARY_IND] = {
                fieldName: 'Custom Proprietary Indicator:',
                displaySeq: 8,
                input: {
                    type: InputFieldType.RADIO,
                    allowedFieldValues: ['Yes', 'No'],
                },
                hasTextField: false,
                hasLookup: false,
            },
            _b[EXTRA_DATA_FIELD_NAMES.ENG_SITE] = {
                fieldName: 'Custom Engineering Site:',
                displaySeq: 9,
                input: {
                    type: InputFieldType.ENUM,
                    allowedFieldValues: __spreadArray([''], Object.values(CustomEngSite), true),
                },
                hasTextField: false,
                hasLookup: false,
            },
            _b[EXTRA_DATA_FIELD_NAMES.BUSINESS_UNIT_CODE] = {
                fieldName: 'Business Unit:',
                displaySeq: 10,
                input: {
                    type: InputFieldType.ENUM,
                    allowedFieldValues: Object.keys(BUSINESS_UNIT_CODE_VALUE_MAPPINGS),
                },
                hasTextField: false,
                hasLookup: false,
            },
            _b[EXTRA_DATA_FIELD_NAMES.BRAND_CODE] = {
                fieldName: 'Brand:',
                displaySeq: 11,
                input: {
                    type: InputFieldType.ENUM,
                    allowedFieldValues: Object.values(BRAND_CODE),
                },
                hasTextField: false,
                hasLookup: false,
            },
            _b),
    };
    useEffect(function () {
        setFieldValues(function (cur) {
            cur[EXTRA_DATA_FIELD_NAMES.WEIGHT_CLASS_CODE].loading = weightClassCodeValidate.loading;
            cur[EXTRA_DATA_FIELD_NAMES.WEIGHT_CLASS_CODE].customErrorMsg = weightClassCodeValidate.errorMessage;
            return __assign({}, cur);
        });
    }, [weightClassCodeValidate.loading, weightClassCodeValidate.errorMessage]);
    useEffect(function () {
        setFieldValues(function (cur) {
            cur[EXTRA_DATA_FIELD_NAMES.PRODUCT_FUNCTION_CODE].loading = productFunctionCodeValidate.loading;
            cur[EXTRA_DATA_FIELD_NAMES.PRODUCT_FUNCTION_CODE].customErrorMsg = productFunctionCodeValidate.errorMessage;
            return __assign({}, cur);
        });
    }, [productFunctionCodeValidate.loading, productFunctionCodeValidate.errorMessage]);
    useEffect(function () {
        var _a;
        if (!((_a = cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data) === null || _a === void 0 ? void 0 : _a.currentProduct)) {
            return;
        }
        var initialValues = buildFieldValues(cpaProductContext.data.currentProduct);
        setFieldValues(initialValues);
    }, [cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data.currentProduct]);
    var handleAction = function (actionType) { return __awaiter(_this, void 0, void 0, function () {
        var cpn, sessionId, user, err_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!((_a = cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data) === null || _a === void 0 ? void 0 : _a.currentProduct)) {
                        return [2 /*return*/];
                    }
                    if (!(actionType === ActionType.CONFIRM)) return [3 /*break*/, 1];
                    postConfirmationUpdate();
                    return [3 /*break*/, 7];
                case 1:
                    if (!(actionType === ActionType.REVERT)) return [3 /*break*/, 2];
                    setFieldValues(buildFieldValues(cpaProductContext.data.currentProduct));
                    return [3 /*break*/, 7];
                case 2:
                    if (!(actionType === ActionType.EDIT)) return [3 /*break*/, 7];
                    cpn = cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data.cpn;
                    sessionId = sessionStorage.getItem("".concat(cpn, "_identifier"));
                    if (!(cpn && sessionId)) return [3 /*break*/, 7];
                    return [4 /*yield*/, getUserOrSignIn()];
                case 3:
                    user = _b.sent();
                    _b.label = 4;
                case 4:
                    _b.trys.push([4, 6, , 7]);
                    return [4 /*yield*/, createLock(cpn, user.name, sessionId, cpaProductContext.data.currentProduct.startDate)];
                case 5:
                    _b.sent();
                    return [3 /*break*/, 7];
                case 6:
                    err_1 = _b.sent();
                    setBannerMessage("This record is locked because it's currently being edited by somone else. Please reload by clicking here: ");
                    setBannerType(BannerMessageType.Warning);
                    setBannerIcon(BannerIconType.Error);
                    setShowBanner(true);
                    setIsRefreshEnabled(true);
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var postConfirmationUpdate = function () {
        updateCurrentProductCustomFields(colDef);
        cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.dispatch({
            type: 'UPDATE_CURRENT_PRODUCT',
            payload: __assign({}, cpaProductContext.data.currentProduct),
        });
    };
    function updateCurrentProductCustomFields(def) {
        if (!cpaProductContext || !cpaProductContext.data.currentProduct) {
            return;
        }
        Object.keys(fieldValues).forEach(function (propertyName) {
            var _a;
            if (cpaProductContext.data.currentProduct) {
                var type = def.fields[propertyName].input.type;
                var currVal_1 = fieldValues[propertyName].value;
                if (type === InputFieldType.STRING ||
                    propertyName === EXTRA_DATA_FIELD_NAMES.COMPLEXITY ||
                    propertyName === EXTRA_DATA_FIELD_NAMES.BRAND_CODE) {
                    cpaProductContext.data.currentProduct[propertyName] = currVal_1;
                }
                if (propertyName === EXTRA_DATA_FIELD_NAMES.FSC_TYPE) {
                    cpaProductContext.data.currentProduct[propertyName] = currVal_1;
                    if (currVal_1 === 'FSC Mix No' || currVal_1 === null) {
                        cpaProductContext.data.currentProduct.fscChainOfCustody = null;
                    }
                    else {
                        cpaProductContext.data.currentProduct.fscChainOfCustody = DEFAULT_FSCCHAINOFCUSTODY;
                    }
                }
                if (propertyName === EXTRA_DATA_FIELD_NAMES.WEIGHT_CLASS_CODE) {
                    cpaProductContext.data.currentProduct[propertyName] = currVal_1;
                }
                if (propertyName === EXTRA_DATA_FIELD_NAMES.PRODUCT_FUNCTION_CODE) {
                    if (currVal_1) {
                        var _b = currVal_1.split(' '), code = _b[0], descriptionParts = _b.slice(1);
                        var description = descriptionParts.join(' ');
                        cpaProductContext.data.currentProduct[propertyName] = code;
                        cpaProductContext.data.currentProduct.productFunctionDesc = description;
                    }
                }
                if (propertyName === EXTRA_DATA_FIELD_NAMES.GSA) {
                    updateChannels(cpaProductContext.data.currentProduct, currVal_1);
                }
                if (propertyName === EXTRA_DATA_FIELD_NAMES.QUOTE_STATUS) {
                    cpaProductContext.data.currentProduct[propertyName] = Object.values(CustomQuoteStatus).find(function (v) { return v === currVal_1; });
                }
                if (propertyName === EXTRA_DATA_FIELD_NAMES.ENG_STATUS) {
                    cpaProductContext.data.currentProduct[propertyName] = Object.values(CustomEngStatus).find(function (v) { return v === currVal_1; });
                }
                if (propertyName === EXTRA_DATA_FIELD_NAMES.ENG_SITE) {
                    cpaProductContext.data.currentProduct[propertyName] = Object.values(CustomEngSite).find(function (v) { return v === currVal_1; });
                }
                if (propertyName === EXTRA_DATA_FIELD_NAMES.BUSINESS_UNIT_CODE) {
                    var busUnitCode_1 = Object.keys(BUSINESS_UNIT_CODE_VALUE_MAPPINGS).find(function (k) { return k === currVal_1; });
                    cpaProductContext.data.currentProduct[propertyName] = busUnitCode_1;
                    (_a = cpaProductContext.data.currentProduct.channels) === null || _a === void 0 ? void 0 : _a.forEach(function (el) {
                        el.busUnitCd = busUnitCode_1;
                    });
                }
                if (propertyName === EXTRA_DATA_FIELD_NAMES.PROPRIETARY_IND) {
                    cpaProductContext.data.currentProduct[propertyName] =
                        currVal_1 === 'Yes';
                }
            }
        });
    }
    return (_jsx(InputFieldsContainer, { colDef: colDef, handleAction: handleAction, fieldValues: fieldValues, setFieldValue: function (property, value) {
            setFieldValues(inputFieldsContainerHelper.getUpdatedFieldValues(fieldValues, property, value));
        } }));
}
function updateChannels(cpaProduct, newValue) {
    if (!cpaProduct.channels) {
        cpaProduct.channels = [];
    }
    if (newValue === 'Yes') {
        var gsaChannel = cpaProduct.channels.find(function (el) { return el.code === GSA_CHANNEL; });
        if (!gsaChannel) {
            cpaProduct.channels.push({
                prcBkPrmtbl: true,
                sifPrmtbl: true,
                cetPrmtbl: true,
                m2mInd: false,
                code: GSA_CHANNEL,
            });
        }
    }
    else {
        cpaProduct.channels = cpaProduct.channels.filter(function (el) { return el.code !== GSA_CHANNEL; });
    }
}
var buildFieldValues = function (currentProduct) {
    var _a;
    var _b;
    return (_a = {},
        _a[EXTRA_DATA_FIELD_NAMES.LEAD_TIME] = {
            value: (currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.minLeadtime) ? 'Assigned' : undefined,
        },
        _a[EXTRA_DATA_FIELD_NAMES.GSA] = {
            value: ((_b = currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.channels) === null || _b === void 0 ? void 0 : _b.find(function (el) { return el.code === GSA_CHANNEL; })) ? 'Yes' : 'No',
        },
        _a[EXTRA_DATA_FIELD_NAMES.FSC_TYPE] = {
            value: currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.fscType,
        },
        _a[EXTRA_DATA_FIELD_NAMES.COMPLEXITY] = {
            value: currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.complexity,
        },
        _a[EXTRA_DATA_FIELD_NAMES.WEIGHT_CLASS_CODE] = {
            value: currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.weightClassCode,
        },
        _a[EXTRA_DATA_FIELD_NAMES.PRODUCT_FUNCTION_CODE] = {
            value: currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.productFunctionCode,
        },
        _a[EXTRA_DATA_FIELD_NAMES.QUOTE_STATUS] = {
            value: currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.quoteStatus,
        },
        _a[EXTRA_DATA_FIELD_NAMES.ENG_STATUS] = {
            value: currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.engStatus,
        },
        _a[EXTRA_DATA_FIELD_NAMES.PROPRIETARY_IND] = {
            value: (currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.proprietaryInd) ? 'Yes' : 'No',
        },
        _a[EXTRA_DATA_FIELD_NAMES.ENG_SITE] = {
            value: currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.engSite,
        },
        _a[EXTRA_DATA_FIELD_NAMES.BRAND_CODE] = {
            value: currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.brandCode,
        },
        _a[EXTRA_DATA_FIELD_NAMES.BUSINESS_UNIT_CODE] = {
            value: currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.businessUnitCode,
        },
        _a);
};
